// extracted by mini-css-extract-plugin
module.exports = {"listItem":"DeviceModel-module--listItem--2Garz","activeListItem":"DeviceModel-module--activeListItem--37pRb"};